// extracted by mini-css-extract-plugin
export default {"wrapper":"input-currency_wrapper__G8yOw","icon":"input-currency_icon__hxNuc","position-right":"input-currency_position-right__AqIqQ"};